import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ButtonElement } from "@/react/types/Element";

// Converts a button element to a FormButtonBlock
export const elementToBlock = (element: ButtonElement): BaseBlock => ({
  id: element.id.toString(),
  type: "FormButtonBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: element.attributes.label,
    },
    backgroundColor: {
      prop: "other",
      type: "string",
      value: element.attributes.background_color,
    },
    textColor: {
      prop: "other",
      type: "string",
      value: element.attributes.text_color,
    },
  },
  meta: {
    elementType: "button",
    elementId: element.id,
    elementableId: element.elementable_id,
    position: element.position,
    parentElementId: element.parent_element_id,
  },
});
